import {Button as PepsicoDsButton} from 'pepsico-ds'

/**
 * Button component that renders a PepsicoDsButton with properties from uiSchema.
 *
 * @param {Object} props - The properties object.
 * @param {string} [props.id] - The id of the button.
 * @param {Function} props.handleButton - The function to handle button click events.
 * @param {Object} props.uiSchema - The schema object containing button properties.
 * @param {string} [props.uiSchema.className] - The CSS class name for the button.
 * @param {string} [props.uiSchema.size] - The size of the button.
 * @param {string} props.uiSchema.title - The text to display on the button.
 * @param {string} [props.uiSchema.variant] - The variant style of the button.
 * @param {boolean} [props.uiSchema.isLoading] - The loading state of the button.
 * @param {ReactNode} [props.uiSchema.iconTrailing] - An optional icon to display at the end of the button.
 * @param {boolean} [props.uiSchema.isDark] - Optional boolean to indicate dark mode styling for the button.
 * @param {boolean} [props.uiSchema.disabled] -  props.disabled - To disable the button.
 * @param {ReactNode} [props.uiSchema.iconLeading] - An optional icon to display at the beginning of the button.
 *
 * @returns {JSX.Element} The rendered PepsicoDsButton component.
 */
const Button = ({id, handleButton, uiSchema = {}, children}) => {
  const {className, size, title, variant, isLoading, iconTrailing, isDark = false, disabled, iconLeading} = uiSchema

  return (
    <PepsicoDsButton
      id={`button` + (id ? `_${id}` : '')}
      data-testid={`button` + (id ? `_${id}` : '')}
      text={title}
      onClick={handleButton}
      variant={variant}
      size={size}
      className={className}
      isLoading={isLoading}
      iconTrailing={iconTrailing}
      isDark={isDark}
      disabled={disabled}
      iconLeading={iconLeading}
    >
      {children}
    </PepsicoDsButton>
  )
}

export default Button
